import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'portfolio',
      component: () => import(/* webpackChunkName: "portfolio" */ './views/Portfolio.vue')
    },
    {
      path: '/portfolio',
      name: 'portfolioMobile',
      component: () => import(/* webpackChunkName: "portfolioMobile" */ './views/PortfolioMobile.vue')
    },
    {
      path: '/resume',
      name: 'resume',
      component: () => import(/* webpackChunkName: "resume" */ './views/Resume.vue')
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import(/* webpackChunkName: "contacts" */ './views/Contacts.vue')
    },
    {
      path: '/portfolio/:slug',
      name: 'portfolio-detail',
      component: () => import(/* webpackChunkName: "portfolio-detail" */ './views/PortfolioDetail.vue')
    },
    {
      path: '/404',
      name: 'error-404',
      component: () => import(/* webpackChunkName: "error" */ './views/Error.vue')
    },
    {
      path: '*',
      redirect: '/404'
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
})
